module.exports = __webpack_public_path__ + "img/154.e3fe28ae.jpg";